module.exports = __webpack_public_path__ + "static/after-1-d06612c3711cc602487ed69286bb581e.png";